import { z } from 'zod';
/** Admin view of integration settings. The OpenRouter key is never returned in
 *  full — only whether it's set and a masked preview. */
export const settingsDtoSchema = z.object({
    openrouterKeySet: z.boolean(),
    openrouterKeyMasked: z.string().nullable(),
    openrouterModel: z.string(),
});
export const updateSettingsSchema = z.object({
    // Empty string is ignored (keeps the current key); a value replaces it.
    openrouterKey: z.string().trim().max(200).optional(),
    openrouterModel: z.string().trim().max(120).optional(),
});
